import { i18n } from '../../i18n/translate';
import type { MenuEnvironment, MenuItem } from './types';

export const ceosLeft = (environment: MenuEnvironment): MenuItem => {
  const { MENU_DOMAIN_FOR_FRONT_END } = environment;

  return {
    id: 'foundry--universal_navigation--menus--ceos_left',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--ceos_left',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    submenu_items: [
      {
        id: '',
        slug: '',
        title: i18n.t('Home'),
        icon: 'house-chimney',
        font_family: '',
        css_class: '',
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/ceos/district-dashboard`,
        target_method: '',
        new_window: false,
        permissions: [{ has_rule_set: ['k12'] }],
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        title: i18n.t('Home'),
        icon: 'house-chimney',
        font_family: '',
        css_class: '',
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/ceos/impact-dashboard`,
        target_method: '',
        new_window: false,
        permissions: [{ not_rule_set: ['k12'] }],
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        title: i18n.t('Reports'),
        icon: 'chart-column',
        font_family: '',
        css_class: '',
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/ceos/reports`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 200,
      },
      {
        id: '',
        slug: '',
        title: i18n.t('Explore Courses'),
        icon: 'books',
        font_family: '',
        css_class: '',
        target_url: 'https://everfi.com/k-12/course-listing/',
        target_method: '',
        new_window: true,
        permissions: [{ has_rule_set: ['k12'] }],
        subsection: false,
        submenu_items: [],
        weight: 300,
      },
    ],
  };
};
